const ConsumerFinances = (() => {
    //Inputs
    let ConsumerFinanceEntriesTable = [];
    let CFConsumerBtns;
    let consumerRow;
    let consumerElement;
    let filterPopup;
    var selectedConsumers;
    var selectedConsumersName;
    var selectedConsumersId;
    //filter
    let accountDropdown;
    let filterValues;
    let btnWrap;
    let activityStartDateBtnWrap;
    let activityEndDateBtnWrap;
    let minamountBtnWrap;
    let maxamountBtnWrap;
    let transectionTypeBtnWrap;
    let accountNameBtnWrap;
    let payeeBtnWrap;
    let categoryBtnWrap;
    let enteredByBtnWrap;
    let isattachmentBtnWrap;
    let accountPermission;
    let tempAccountPer;  

    //service filter options
    let selectedConsumerIds;
    let globalSelectedAccountName = '';
    let globalAccountDropdownOptions = [];

    let reconciliationFilterOn = false;
    let reconcileFilterValues;
    let tableUnreconciled;
    let selectedId;
    let selectedAccountData;
    let reconcilePageData;
    let reconcileGridData;
    let reconcilePopup;

    // get the Consumers selected from the Roster
    async function handleActionNavEvent(target) {
        var targetAction = target.dataset.actionNav;

        switch (targetAction) {
            case 'miniRosterDone': {
                selectedConsumers = roster2.getActiveConsumers();
                filterValues = undefined;
                await loadConsumerFinanceLanding();
                DOM.toggleNavLayout();
                break;
            }
            case 'miniRosterCancel': {
                DOM.toggleNavLayout();
                loadApp('home');
                break;
            }
        }
    }

    async function backFromConsumerFinanceEditAccount(Consumers) {
        setActiveModuleAttribute('ConsumerFinances');
        DOM.clearActionCenter();
        selectedConsumers = Consumers;
        filterValues = undefined;
        await loadConsumerFinanceLanding();
        DOM.toggleNavLayout();
    }

    // Build Consumer Finance Module Landing Page
    async function loadConsumerFinanceLanding(value) {
        DOM.clearActionCenter();
        DOM.scrollToTopOfPage();
        showMiniRosterBtn(true);
        if (!filterValues) {
            buildNewFilterBtn();
        }
        if (typeof value === 'string') {
            filterValues.accountName = value;
        } else if (typeof value === 'object' && value !== null) {        
            if (value.accountName) filterValues.accountName = value.accountName;
            if (value.selectedConsumers) selectedConsumers = value.selectedConsumers;
            if (value.fromDate) filterValues.activityStartDate = value.fromDate;
        }
        if (selectedConsumers && selectedConsumers.length > 0) {
            selectedConsumersId = selectedConsumers[selectedConsumers.length - 1].id;
            $.session.consumerId = selectedConsumersId;
        } else {
            dashboard.load();
            return;
        }

        const name = (
            await ConsumerFinancesAjax.getConsumerNameByID({
                token: $.session.Token,
                consumerId: selectedConsumersId,
            })
        ).getConsumerNameByIDResult;

        getaccountPermission();

        selectedConsumersName = name[0].FullName;
        const topButton = buildHeaderButton(selectedConsumers[0]);
        landingPage = document.createElement('div');
        landingPage.appendChild(topButton);
        filterRow = document.createElement('div');
        filterRow.classList.add('filterElement');

        const filteredBy = buildFilteredBy();
        filterRow.appendChild(filteredBy);
        landingPage.appendChild(filterRow);
        ConsumerFinanceEntriesTable = await buildConsumerFinanceEntriesTable(filterValues);
        landingPage.appendChild(ConsumerFinanceEntriesTable);
        populateAccountDropdown();
        DOM.ACTIONCENTER.appendChild(landingPage);
    }

    function getaccountPermission() {
        accountPermission = '';
        tempAccountPer = [];
        if ($.session.CFViewChecking) tempAccountPer.push('Checking');

        if ($.session.CFViewCraditCard) {
            tempAccountPer.push('Credit Card');
        }

        if ($.session.CFViewFoodStamp) {
            tempAccountPer.push('Food Stamps');
        }

        if ($.session.CFViewPettyCash) {
            tempAccountPer.push('Petty Cash');
        }

        if ($.session.CFViewShaving) {
            tempAccountPer.push('Savings');
        }

        if ($.session.CFViewChristmasClub) {
            tempAccountPer.push('Christmas Club');
        }
        if ($.session.CFViewSystem20183A) {
            tempAccountPer.push('System 2018.3A');
        }
        if ($.session.CFViewSystem20183) {
            tempAccountPer.push('System 2018.3');
        }
        if ($.session.CFViewOhioEBT) {
            tempAccountPer.push('Ohio EBT');
        }
        if ($.session.CFViewViewFoodStampDebitCardEBT) {
            tempAccountPer.push('Food Stamp Debit Card EBT');
        }

        if (tempAccountPer.length > 0) {
            accountPermission = tempAccountPer.toString();
        } else accountPermission = '';
    }

    // build the listing of OOD Entries (based off of filter settings)
    async function buildConsumerFinanceEntriesTable(filterValues) {
        const tableOptions = {
            plain: false,
            tableId: 'singleEntryAdminReviewTable',
            headline: selectedConsumersName,
            columnHeadings: ['Date', 'Account', 'Payee', 'Category', 'Amount', 'Check No.', 'Balance', 'Entered By'],
            endIcon: true,
        };

        selectedConsumerIds = selectedConsumers.map(function (x) {
            return x.id;
        });
        let ConsumerFinancesEntries = await ConsumerFinancesAjax.getAccountTransectionEntriesAsync(
            selectedConsumerIds.join(', '),
            filterValues.activityStartDate,
            filterValues.activityEndDate,
            filterValues.accountName,
            filterValues.payee,
            filterValues.category,
            filterValues.minamount,
            filterValues.maxamount,
            filterValues.checkNo,
            filterValues.Balance,
            filterValues.enteredBy,
            filterValues.isattachment,
            filterValues.transectionType,
            accountPermission,
        );

        ConsumerFinancesEntries.getAccountTransectionEntriesResult.forEach(function (entry) {
            let newDate = new Date(entry.activityDate);
            let theMonth = newDate.getMonth() + 1;
            let formatActivityDate =
                UTIL.leadingZero(theMonth) + '/' + UTIL.leadingZero(newDate.getDate()) + '/' + newDate.getFullYear();
            entry.activityDate = formatActivityDate;
        });

        let tableData = ConsumerFinancesEntries.getAccountTransectionEntriesResult.map(entry => {
            let checkNo = entry.checkno;
            let category = entry.category;
            let payee = entry.payee;

            if (entry.categoryCode !== 'C') {
                category = '';
                payee = entry.payee2;

                if (entry.categoryCode === 'T') {
                    checkNo = 'Transfer';
                }
            }

            return {
                values: [
                    entry.activityDate,
                    entry.account,
                    payee,
                    category,
                    '$' + entry.amount,
                    checkNo,
                    '$' + entry.balance,
                    entry.enteredby,
                ],
                attributes: [
                    { key: 'registerId', value: entry.ID },
                    { key: 'data-plan-active', value: entry.isExpance },
                ],
                onClick: e => {
                    if (entry.categoryCode === 'C') {
                        handleAccountTableEvents(e.target.attributes.registerId.value);
                    }
                },
                endIcon: entry.AttachmentsID == 0 ? `${icons['Empty']}` : `${icons['attachmentSmall']}`,
            };
        });
        const oTable = table.build(tableOptions);

        // Set the data type for each header, for sorting purposes
        const headers = oTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'date'); // Date
        headers[1].setAttribute('data-type', 'string'); // Account
        headers[2].setAttribute('data-type', 'string'); // Payee
        headers[3].setAttribute('data-type', 'string'); // Category
        headers[4].setAttribute('data-type', 'amount'); // Amount
        headers[5].setAttribute('data-type', 'string'); // Check No
        headers[6].setAttribute('data-type', 'amount'); // Balance
        headers[7].setAttribute('data-type', 'string'); // Enter By

        // Call function to allow table sorting by clicking on a header.
        table.sortTableByHeader(oTable);

        table.populate(oTable, tableData);

        return oTable;
    }

    function handleAccountTableEvents(registerId) {
        NewEntryCF.buildNewEntryForm(registerId);
    }

    // build display of Account and button
    function buildHeaderButton(consumer) {
        consumerElement = document.createElement('div');
        consumerRow = document.createElement('div');
        consumerRow.classList.add('consumerHeader');
        CFConsumerBtns = buildButtonBar(consumer);
        consumerRow.appendChild(CFConsumerBtns);
        consumerElement.appendChild(consumerRow);
        return consumerElement;
    }

    function buildButtonBar(consumer) {
        const buttonBar = document.createElement('div');
        buttonBar.classList.add('OODbuttonBar');
        buttonBar.style.maxHeight = '50px';
        buttonBar.style.minWidth = '100%';

        const dropdownButtonBar = document.createElement('div');
        const entryButtonBar = document.createElement('div');
        const editButtonBar = document.createElement('div');
        const reconcileButtonBar = document.createElement('div');
        const reportButtonBar = document.createElement('div');

        dropdownButtonBar.style.width = '19%';
        entryButtonBar.style.width = '19%';
        editButtonBar.style.width = '19%';
        reconcileButtonBar.style.width = '19%';
        reportButtonBar.style.width = '19%';

        accountDropdown = dropdown.build({
            label: 'Accounts:',
            dropdownId: 'accountDropdown',
        });      

        const entryBtn = button.build({
            text: '+ New Entry',
            style: 'secondary',
            type: 'contained',
            classNames: 'newEntryBtn',
            callback: async () => {
                if (!entryBtn.classList.contains('disabled')) {
                    let accountName = filterValues.accountName == '%' ? undefined : filterValues.accountName;
                    NewEntryCF.init(accountName);
                }
            },
        });

        const editAccountBtn = button.build({
            text: 'Edit Accounts',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                if (!editAccountBtn.classList.contains('disabled')) {
                    CFEditAccount.loadCFEditFromAccountRegister(selectedConsumers);
                }
            },
        });

        const reconcileAccountBtn = button.build({
            id:'reconcileAccountBtn',
            text: 'Reconcile Account',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                if (!reconcileAccountBtn.classList.contains('disabled')) {
                    showReconcileAccountPopup(null);
                }
            },
        });
        reconcileAccountBtn.classList.add('disabled');

        accountDropdown.addEventListener('change', event => {
            filterValues.accountName = event.target.value;
            // Update global selected account name
            if (event.target.value !== '%') {
                const selectedOption = event.target.options[event.target.selectedIndex];
                globalSelectedAccountName = selectedOption.text;
            } else {
                globalSelectedAccountName = 'ALL';
            }
            loadConsumerFinanceLanding(filterValues.accountName);
        });
        function createMainReportButton(buttonsData) {
            return button.build({
                text: 'Reports',
                icon: 'add',
                style: 'secondary',
                type: 'contained',
                classNames: 'entryBtn',
                callback: function () {
                    // Iterate through each item in the buttonsData array
                    buttonsData.forEach(function (buttonData) {
                        buttonData.filterValues = getReportValues();   
                    });

                    generateReports.showReportsPopup(buttonsData);
                },
            });
        }
        reportsBtn = createMainReportButton([{ text: 'Account Register' }])

        if ($.session.CFInsert) {
            entryBtn.classList.remove('disabled');
        } else {
            entryBtn.classList.add('disabled');
        }

        if ($.session.CFViewEditAccounts) {
            editAccountBtn.classList.remove('disabled');
        } else {
            editAccountBtn.classList.add('disabled');
        }

        entryBtn.style.height = '50px';
        entryBtn.style.minWidth = '100%';
        editAccountBtn.style.height = '50px';
        editAccountBtn.style.minWidth = '100%';
        reconcileAccountBtn.style.height = '50px';
        reconcileAccountBtn.style.minWidth = '100%';
        reportsBtn.style.height = '50px';
        reportsBtn.style.minWidth = '100%';

        buildNewFilterBtn();
        accountDropdown.style.minWidth = '100%';
        dropdownButtonBar.appendChild(accountDropdown);
        editButtonBar.appendChild(editAccountBtn);
        editButtonBar.style.marginLeft = '1%';
        reconcileButtonBar.appendChild(reconcileAccountBtn);
        reconcileButtonBar.style.marginLeft = '1%';
        reportButtonBar.appendChild(reportsBtn);
        reportButtonBar.style.marginLeft = '1%';
        entryButtonBar.appendChild(entryBtn);
        entryButtonBar.style.marginLeft = '1%';
        buttonBar.appendChild(dropdownButtonBar);
        buttonBar.appendChild(editButtonBar);
        buttonBar.appendChild(reconcileButtonBar);
        buttonBar.appendChild(entryButtonBar);
        buttonBar.appendChild(reportButtonBar);       
        return buttonBar;
    }

    function buildNewFilterBtn() {
        if (!filterValues)
            filterValues = {
                token: $.session.Token,
                activityStartDate: UTIL.formatDateFromDateObj(dates.subDays(new Date(), 30)),
                activityEndDate: UTIL.getTodaysDate(),
                accountName: '%',
                payee: '%',
                category: '%',
                minamount: '-10000.00',
                maxamount: '10000.00',
                checkNo: '',
                Balance: '',
                enteredBy: '%',
                isattachment: '%',
                transectionType: '%',
            };
    }

    function getReportValues() {
        return (reportValues = {
            consumerID: selectedConsumersId, 
            activityStartDate: filterValues.activityStartDate == null ? UTIL.formatDateFromDateObj(dates.subDays(new Date(), 30)) : filterValues.activityStartDate,
            activityEndDate: filterValues.activityEndDate == null ? UTIL.getTodaysDate() : filterValues.activityEndDate,
            minamount: filterValues.minamount == undefined ? '-10000.00' : filterValues.minamount,
            maxamount: filterValues.maxamount == undefined ? '10000.00' : filterValues.maxamount,
            accountName: filterValues.accountName == undefined ? '%' : filterValues.accountName,
            enteredBy: filterValues.enteredBy == undefined ? '%' : filterValues.enteredBy,
            payee: filterValues.payee == undefined ? '%' : filterValues.payee,
            category: filterValues.category == undefined ? '%' : filterValues.category,
            isattachment: filterValues.isattachment == undefined ? '%' : filterValues.isattachment,
            transectionType: filterValues.transectionType == undefined ? '%' : filterValues.transectionType,
            accountPer: accountPermission,
        });
    }

    // Populate the Account DDL
    async function populateAccountDropdown() {
        const { getActiveAccountResult: accounts } = await ConsumerFinancesAjax.getActiveAccountAsync(
            selectedConsumersId,
            accountPermission,
        );
        let data = accounts.map(account => ({
            id: account.accountId,
            value: account.accountName,
            text: account.accountName + ' - $' + (account.totalBalance == '' ? '0.00' : account.totalBalance),
            accountId: account.accountId,
            reconciledDate: moment(account.reconciledDate || '').format('YYYY-MM-DD'),
            reconciledBalance: account.reconciledBalance || '0.00',
            priorReconciledDate: moment(account.priorReconciledDate || '').format('YYYY-MM-DD'),
            priorReconciledBalance: account.priorReconciledBalance || '0.00'
        }));
        if (data.length > 0) data.unshift({ id: null, value: '%', text: 'ALL' }); 
        // Store globally for reconcile popup
        globalAccountDropdownOptions = data;
        let selectedValue = filterValues.accountName;
        const accountExists = data.some(account => account.value === filterValues.accountName);
        if (!accountExists && filterValues.accountName !== '%') {
            selectedValue = '%';
            filterValues.accountName = '%'; 
            loadConsumerFinanceLanding();      
            return;
        }
        dropdown.populate('accountDropdown', data, selectedValue);

        if (selectedValue !== '%') {
            const selectedAccount = data.find(acc => acc.value === selectedValue);
            globalSelectedAccountName = selectedAccount ? selectedAccount.text : '';
            toggleReconcilebtnStatus(true);
        } else {
            globalSelectedAccountName = 'ALL';
            toggleReconcilebtnStatus(false);
        }       
    }
    function toggleReconcilebtnStatus(status) {
        const reconcileAccountBtn = document.getElementById('reconcileAccountBtn');
        if (reconcileAccountBtn) {
            if (status) {
                reconcileAccountBtn.classList.remove('disabled');
            }
            else {
                reconcileAccountBtn.classList.add('disabled');
            }
        }
    }
    async function showReconcileAccountPopup(data) {
        const selectedAccountText = globalSelectedAccountName;
        if (!selectedAccountText || selectedAccountText === 'ALL' || selectedAccountText.includes('%')) {
            alert('Please select a specific account to reconcile.');
            return;
        }

        const popup = POPUP.build({
            hideX: true,
        });

        const reconcileAccountDropdown = dropdown.build({
            label: 'Account',
            dropdownId: 'reconcileAccountDropdown',
        });
        popup.appendChild(reconcileAccountDropdown);

        const filteredAccounts = globalAccountDropdownOptions.filter(acc =>
            acc.value !== '%' && acc.text !== 'ALL'
        );

        const selectedAccountObj = filteredAccounts.find(
            acc => acc.text.trim().toLowerCase().startsWith(selectedAccountText.trim().toLowerCase())
        );

        const selectedValue = selectedAccountObj?.value ?? (filteredAccounts.length > 0 ? filteredAccounts[0].value : null);
        selectedId = selectedAccountObj?.id ?? (filteredAccounts.length > 0 ? filteredAccounts[0].id : null);

        setTimeout(() => {
            dropdown.populate('reconcileAccountDropdown', filteredAccounts, selectedValue);

            const selectEl = document.getElementById('reconcileAccountDropdown');
            if (selectEl) {
                selectEl.addEventListener('change', async (event) => {
                    const selectedValue = event.target.value;
                    const selectedAccount = filteredAccounts.find(acc => acc.value === selectedValue);
                    selectedId = selectedAccount?.id;
                    selectedAccountData = selectedAccount || {};

                    const lastDateInput = document.getElementById('lastReconciledDate');
                    const lastBalanceInput = document.getElementById('lastReconciledBalance');

                    if (lastDateInput) {
                        lastDateInput.value = selectedAccount?.reconciledDate || '';
                        lastDateInput.classList.add('disabled');
                    }
                    if (lastBalanceInput) {
                        lastBalanceInput.value = selectedAccount?.reconciledBalance || '0.00';
                        lastBalanceInput.classList.add('disabled');
                    }

                    validateForm();
                });
            }

            if (selectedValue && filteredAccounts.length > 0) {
                const initialAccount = filteredAccounts.find(acc => acc.value === selectedValue);
                if (initialAccount) {
                    selectedAccountData = initialAccount;
                }
            }
        }, 0);

        const lastDateInput = input.build({
            id: 'lastReconciledDate',
            type: 'date',
            label: 'Last Reconciled Date',
            disabled: true,
        });

        const lastBalanceInput = input.build({
            id: 'lastReconciledBalance',
            type: 'text',
            label: 'Last Reconciled Bal.',
            disabled: true,
        });

        const statementDateInput = input.build({
            id: 'statementDate',
            type: 'date',
            label: 'Statement Date *',
            required: true,
            value: data?.statementDate ?? null
        });

        const statementBalanceInput = input.build({
            id: 'statementBalance',
            type: 'text',
            label: 'Statement Balance *',
            required: true,
            value: data?.statementBalance ?? ''
        });

        const interestInput = input.build({
            id: 'interest',
            type: 'text',
            label: 'Interest',
            value: parseFloat(data?.interest ?? '0.00').toFixed(2)
        });

        const serviceInput = input.build({
            id: 'service',
            type: 'text',
            label: 'Service',
            value: parseFloat(data?.service ?? '0.00').toFixed(2)
        });

        const reconcileBtn = button.build({
            text: 'RECONCILE',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: async () => {
                if (!reconcileBtn.classList.contains('disabled')) {
                    await startReconciliation();
                }
            }
        });

        const undoBtn = button.build({
            text: 'UNDO LAST RECONCILIATION',
            style: 'secondary',
            type: 'contained',
            classNames: 'disabled',
            callback: () => {
                if (!undoBtn.classList.contains('disabled')) {
                    POPUP.hide(popup);
                    showUndoConfirmationPopup();
                }
            }
        });

        const cancelBtn = button.build({
            text: 'CANCEL',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(popup);
                loadConsumerFinanceLanding(filterValues.accountName);
            }
        });

        function createRow(leftEl, rightEl) {
            const row = document.createElement('div');
            row.style.display = 'flex';
            row.style.gap = '10px';
            row.style.marginTop = '10px';
            leftEl.style.flex = rightEl.style.flex = '1';
            row.appendChild(leftEl);
            row.appendChild(rightEl);
            return row;
        }

        popup.appendChild(createRow(lastDateInput, lastBalanceInput));
        popup.appendChild(createRow(statementDateInput, statementBalanceInput));
        popup.appendChild(createRow(interestInput, serviceInput));

        const buttonRow = document.createElement('div');
        buttonRow.style.display = 'flex';
        buttonRow.style.gap = '10px';
        buttonRow.style.marginTop = '15px';
        reconcileBtn.style.flex = undoBtn.style.flex = '1';
        buttonRow.appendChild(reconcileBtn);
        buttonRow.appendChild(undoBtn);
        popup.appendChild(buttonRow);

        const cancelRow = document.createElement('div');
        cancelRow.style.marginTop = '10px';
        cancelRow.style.width = '100%';
        cancelBtn.style.width = '100%';
        cancelRow.appendChild(cancelBtn);
        popup.appendChild(cancelRow);

        function validateForm() {
            const statementDate = document.getElementById('statementDate');
            const statementBalance = document.getElementById('statementBalance');
            const lastDate = document.getElementById('lastReconciledDate');

            const hasValidDate = statementDate && statementDate.value;
            const hasValidBalance = statementBalance && statementBalance.value && statementBalance.value.trim() !== '';
            const hasLastDate = lastDate && lastDate.value;

            let isDateValid = true;
            if (hasValidDate && hasLastDate && lastDate.value) {
                if (new Date(statementDate.value) <= new Date(lastDate.value)) {
                    isDateValid = false;
                    statementDate.parentElement.classList.add('error');
                } else {
                    statementDate.parentElement.classList.remove('error');
                }
            } else if (!hasValidDate) {
                statementDate.parentElement.classList.add('error');
            } else {
                statementDate.parentElement.classList.remove('error');
            }

            if (!hasValidBalance) {
                statementBalance.parentElement.classList.add('error');
            } else {
                statementBalance.parentElement.classList.remove('error');
            }

            if (hasValidDate && hasValidBalance && isDateValid) {
                reconcileBtn.classList.remove('disabled');
            } else {
                reconcileBtn.classList.add('disabled');
            }

            if (selectedAccountData && selectedAccountData.priorReconciledDate && parseFloat(selectedAccountData.priorReconciledBalance) > 0) {
                undoBtn.classList.remove('disabled');
            } else {
                undoBtn.classList.add('disabled');
            }
        }

        setTimeout(() => {
            const statementDate = document.getElementById('statementDate');
            const statementBalance = document.getElementById('statementBalance');
            const interest = document.getElementById('interest');
            const service = document.getElementById('service');

            if (statementDate) {
                statementDate.addEventListener('change', validateForm);
                statementDate.addEventListener('input', validateForm);
            }

            if (statementBalance) {
                statementBalance.addEventListener('change', validateForm);
                statementBalance.addEventListener('input', validateForm);

                statementBalance.addEventListener('keyup', (e) => {
                    let value = e.target.value;
                    const reg = /^[0-9.$\-\s]+$/;
                    if (!reg.test(value)) {
                        e.target.value = value.substring(0, value.length - 1);
                        return;
                    }
                    if (value.includes('.')) {
                        const parts = value.split('.');
                        if (parts.length > 2 || (parts[1] && parts[1].length > 2)) {
                            e.target.value = value.substring(0, value.length - 1);
                            return;
                        }
                    }
                    validateForm();
                });
            }

            [interest, service].forEach(input => {
                if (input) {
                    input.addEventListener('keyup', (e) => {
                        let value = e.target.value;
                        const reg = /^[0-9.$\-\s]+$/;
                        if (!reg.test(value)) {
                            e.target.value = value.substring(0, value.length - 1);
                            return;
                        }
                        if (value.includes('.')) {
                            const parts = value.split('.');
                            if (parts.length > 2 || (parts[1] && parts[1].length > 2)) {
                                e.target.value = value.substring(0, value.length - 1);
                                return;
                            }
                        }
                    });
                }
            });

            validateForm();

            if (selectedValue && filteredAccounts.length > 0) {
                const selectEl = document.getElementById('reconcileAccountDropdown');
                if (selectEl) {
                    const changeEvent = new Event('change');
                    selectEl.dispatchEvent(changeEvent);
                }
            }
        }, 100);

        reconcilePopup = popup;
        POPUP.show(popup);
    }
       

    function validateReconcileForm(reconcileBtn, undoBtn) {
        const statementDate = document.getElementById('statementDate');
        const statementBalance = document.getElementById('statementBalance');
        const lastReconciledDate = document.getElementById('lastReconciledDate');

        let isValid = true;

        if (!statementDate.value) {
            statementDate.style.border = '2px solid red';
            isValid = false;
        } else {
            statementDate.style.border = '';

            if (lastReconciledDate.value && new Date(statementDate.value) <= new Date(lastReconciledDate.value)) {
                statementDate.style.border = '2px solid red';
                isValid = false;
            }
        }

        if (isNaN(parseFloat(statementBalance.value.replace(/[$,]/g, '')))) {
            statementBalance.style.border = '2px solid red';
            isValid = false;
        } else {
            statementBalance.style.border = '';
        }

        if (isValid) {
            reconcileBtn.classList.remove('disabled');
        } else {
            reconcileBtn.classList.add('disabled');
        }

        if (selectedAccountData.priorReconciledDate && parseFloat(selectedAccountData.priorReconciledBalance) > 0) {
            undoBtn.classList.remove('disabled');
        } else {
            undoBtn.classList.add('disabled');
        }
    }

    // build the display of the current Filter Settings (next to the Filter button)
    function buildFilteredBy() {
        var filteredBy = document.querySelector('.filteredByData');

        if (!filteredBy) {
            filteredBy = document.createElement('div');
            filteredBy.classList.add('filteredByData');
            filterButtonSet();
            filteredBy.appendChild(btnWrap);
        }

        filteredBy.style.maxWidth = '100%';

        if (filterValues.transectionType === '%' || filterValues.transectionType === 'ALL') {
            btnWrap.appendChild(transectionTypeBtnWrap);
            btnWrap.removeChild(transectionTypeBtnWrap);
        } else {
            btnWrap.appendChild(transectionTypeBtnWrap);
        }

        if (filterValues.accountName === '%' || filterValues.accountName === 'ALL') {
            btnWrap.appendChild(accountNameBtnWrap);
            btnWrap.removeChild(accountNameBtnWrap);
        } else {
            btnWrap.appendChild(accountNameBtnWrap);
        }

        if (filterValues.payee === '%' || filterValues.payee === 'ALL') {
            btnWrap.appendChild(payeeBtnWrap);
            btnWrap.removeChild(payeeBtnWrap);
        } else {
            btnWrap.appendChild(payeeBtnWrap);
        }

        if (filterValues.category === '%' || filterValues.category === 'ALL') {
            btnWrap.appendChild(categoryBtnWrap);
            btnWrap.removeChild(categoryBtnWrap);
        } else {
            btnWrap.appendChild(categoryBtnWrap);
        }

        if (filterValues.enteredBy === '%' || filterValues.enteredBy === 'ALL') {
            btnWrap.appendChild(enteredByBtnWrap);
            btnWrap.removeChild(enteredByBtnWrap);
        } else {
            btnWrap.appendChild(enteredByBtnWrap);
        }
        if (filterValues.isattachment === '%' || filterValues.isattachment === 'ALL') {
            btnWrap.appendChild(isattachmentBtnWrap);
            btnWrap.removeChild(isattachmentBtnWrap);
        } else {
            btnWrap.appendChild(isattachmentBtnWrap);
        }
        return filteredBy;
    }

    function filterButtonSet() {
        filterBtn = button.build({
            text: 'Filter',
            icon: 'filter',
            style: 'secondary',
            type: 'contained',
            classNames: 'filterBtnNew',
            callback: () => {
                buildFilterPopUp('ALL');
            },
        });
        activityStartDateBtn = button.build({
            id: 'activityStartDateBtn',
            text: 'From Date: ' + moment(filterValues.activityStartDate, 'YYYY-MM-DD').format('M/D/YYYY'),
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('activityStartDateBtn');
            },
        });
        activityEndDateBtn = button.build({
            id: 'activityEndDateBtn',
            text: 'To date: ' + moment(filterValues.activityEndDate, 'YYYY-MM-DD').format('M/D/YYYY'),
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('activityEndDateBtn');
            },
        });
        minamountBtn = button.build({
            id: 'minamountBtn',
            text: 'Min Amount: $' + filterValues.minamount,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('minamountBtn');
            },
        });
        maxamountBtn = button.build({
            id: 'maxamountBtn',
            text: 'Max Amount: $' + filterValues.maxamount,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('maxamountBtn');
            },
        });
        transectionTypeBtn = button.build({
            id: 'transectionTypeBtn',
            text: filterValues.transectionType == 'false' ? 'Transaction Type: Deposit' : 'Transaction Type: Expense',
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('transectionTypeBtn');
            },
        });
        transectionTypeCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('transectionTypeBtn');
            },
        });
        accountNameBtn = button.build({
            id: 'accountNameBtn',
            text: 'Account: ' + filterValues.accountName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('accountNameBtn');
            },
        });
        accountNameCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('accountNameBtn');
            },
        });
        payeeBtn = button.build({
            id: 'payeeBtn',
            text: 'Payee: ' + filterValues.payee,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('payeeBtn');
            },
        });
        payeeCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('payeeBtn');
            },
        });
        categoryBtn = button.build({
            id: 'categoryBtn',
            text: 'Category: ' + filterValues.category,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('categoryBtn');
            },
        });
        categoryCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('categoryBtn');
            },
        });
        enteredByBtn = button.build({
            id: 'enteredByBtn',
            text: 'Last Updated By: ' + filterValues.userName,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('enteredByBtn');
            },
        });
        enteredByCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('enteredByBtn');
            },
        });
        isattachmentBtn = button.build({
            id: 'isattachmentBtn',
            text: 'Has Attachment: ' + filterValues.isattachment,
            style: 'secondary',
            type: 'text',
            classNames: 'filterSelectionBtn',
            callback: () => {
                buildFilterPopUp('isattachmentBtn');
            },
        });
        isattachmentCloseBtn = button.build({
            icon: 'Delete',
            style: 'secondary',
            type: 'text',
            classNames: 'filterCloseBtn',
            callback: () => {
                closeFilter('isattachmentBtn');
            },
        });

        btnWrap = document.createElement('div');
        btnWrap.classList.add('filterBtnWrap');
        btnWrap.appendChild(filterBtn);

        activityStartDateBtnWrap = document.createElement('div');
        activityStartDateBtnWrap.classList.add('filterSelectionBtnWrap');
        activityStartDateBtnWrap.appendChild(activityStartDateBtn);
        btnWrap.appendChild(activityStartDateBtnWrap);

        activityEndDateBtnWrap = document.createElement('div');
        activityEndDateBtnWrap.classList.add('filterSelectionBtnWrap');
        activityEndDateBtnWrap.appendChild(activityEndDateBtn);
        btnWrap.appendChild(activityEndDateBtnWrap);

        minamountBtnWrap = document.createElement('div');
        minamountBtnWrap.classList.add('filterSelectionBtnWrap');
        minamountBtnWrap.appendChild(minamountBtn);
        btnWrap.appendChild(minamountBtnWrap);

        maxamountBtnWrap = document.createElement('div');
        maxamountBtnWrap.classList.add('filterSelectionBtnWrap');
        maxamountBtnWrap.appendChild(maxamountBtn);
        btnWrap.appendChild(maxamountBtnWrap);

        transectionTypeBtnWrap = document.createElement('div');
        transectionTypeBtnWrap.classList.add('filterSelectionBtnWrap');
        transectionTypeBtnWrap.appendChild(transectionTypeBtn);
        transectionTypeBtnWrap.appendChild(transectionTypeCloseBtn);
        btnWrap.appendChild(transectionTypeBtnWrap);

        accountNameBtnWrap = document.createElement('div');
        accountNameBtnWrap.classList.add('filterSelectionBtnWrap');
        accountNameBtnWrap.appendChild(accountNameBtn);
        accountNameBtnWrap.appendChild(accountNameCloseBtn);
        btnWrap.appendChild(accountNameBtnWrap);

        payeeBtnWrap = document.createElement('div');
        payeeBtnWrap.classList.add('filterSelectionBtnWrap');
        payeeBtnWrap.appendChild(payeeBtn);
        payeeBtnWrap.appendChild(payeeCloseBtn);
        btnWrap.appendChild(payeeBtnWrap);

        categoryBtnWrap = document.createElement('div');
        categoryBtnWrap.classList.add('filterSelectionBtnWrap');
        categoryBtnWrap.appendChild(categoryBtn);
        categoryBtnWrap.appendChild(categoryCloseBtn);
        btnWrap.appendChild(categoryBtnWrap);

        enteredByBtnWrap = document.createElement('div');
        enteredByBtnWrap.classList.add('filterSelectionBtnWrap');
        enteredByBtnWrap.appendChild(enteredByBtn);
        enteredByBtnWrap.appendChild(enteredByCloseBtn);
        btnWrap.appendChild(enteredByBtnWrap);

        isattachmentBtnWrap = document.createElement('div');
        isattachmentBtnWrap.classList.add('filterSelectionBtnWrap');
        isattachmentBtnWrap.appendChild(isattachmentBtn);
        isattachmentBtnWrap.appendChild(isattachmentCloseBtn);
        btnWrap.appendChild(isattachmentBtnWrap);
    }

    function closeFilter(closeFilter) {
        if (closeFilter == 'transectionTypeBtn') {
            filterValues.transectionType = '%';
        }
        if (closeFilter == 'accountNameBtn') {
            filterValues.accountName = '%';
        }
        if (closeFilter == 'payeeBtn') {
            filterValues.payee = '%';
        }
        if (closeFilter == 'enteredByBtn') {
            filterValues.enteredBy = '%';
        }
        if (closeFilter == 'isattachmentBtn') {
            filterValues.isattachment = '%';
        }
        if (closeFilter == 'categoryBtn') {
            filterValues.category = '%';
        }
        loadConsumerFinanceLanding();
    }

    // build Filter pop-up that displays when an "Filter" button is clicked
    function buildFilterPopUp(IsShow) {
        // popup
        filterPopup = POPUP.build({
            classNames: ['rosterFilterPopup'],
            hideX: true,
        });

        // dropdowns & inputs
        fromDateInput = input.build({
            id: 'fromDateInput',
            type: 'date',
            label: 'From Date',
            style: 'secondary',
            value: filterValues.activityStartDate,
        });

        toDateInput = input.build({
            id: 'toDateInput',
            type: 'date',
            label: 'To Date',
            style: 'secondary',
            value: filterValues.activityEndDate,
        });

        minAmountInput = input.build({
            id: 'minAmountInput',
            type: 'text',
            label: 'Min Amount',
            style: 'secondary',
            value: '$' + (filterValues.minamount ? filterValues.minamount : ''),
        });

        maxAmountInput = input.build({
            id: 'maxAmountInput',
            type: 'text',
            label: 'Max Amount',
            style: 'secondary',
            value: '$' + (filterValues.maxamount ? filterValues.maxamount : ''),
        });

        transectionTypeFilterDropdown = dropdown.build({
            label: 'Transaction Type',
            dropdownId: 'transectionTypeFilterDropdown',
        });

        accountFilterDropdown = dropdown.build({
            label: 'Account',
            dropdownId: 'accountFilterDropdown',
        });

        payeeDropdown = dropdown.build({
            id: 'payeeDropdown',
            label: 'Payee',
            dropdownId: 'payeeDropdown',
        });

        categoryDropdown = dropdown.build({
            id: 'categoryDropdown',
            label: 'Category',
            dropdownId: 'categoryDropdown',
        });

        lastUpdateDropdown = dropdown.build({
            id: 'lastUpdateDropdown',
            label: 'Last Updated By',
            dropdownId: 'lastUpdateDropdown',
        });

        isAttachedDropdown = dropdown.build({
            id: 'isAttachedDropdown',
            label: 'Has Attachment?',
            dropdownId: 'isAttachedDropdown',
        });

        // apply filters button
        APPLY_BTN = button.build({
            text: 'Apply',
            style: 'secondary',
            type: 'contained',
        });
        CANCEL_BTN = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => filterPopupCancelBtn(),
        });

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.appendChild(APPLY_BTN);
        btnWrap.appendChild(CANCEL_BTN);

        var dateWrap = document.createElement('div');
        dateWrap.classList.add('dateWrap');
        if (IsShow == 'ALL' || IsShow == 'activityStartDateBtn') dateWrap.appendChild(fromDateInput);
        if (IsShow == 'ALL' || IsShow == 'activityEndDateBtn') dateWrap.appendChild(toDateInput);

        var amountWrap = document.createElement('div');
        amountWrap.classList.add('dateWrap');
        if (IsShow == 'ALL' || IsShow == 'minamountBtn') amountWrap.appendChild(minAmountInput);
        if (IsShow == 'ALL' || IsShow == 'maxamountBtn') amountWrap.appendChild(maxAmountInput);

        // build popup
        filterPopup.appendChild(dateWrap);
        filterPopup.appendChild(amountWrap);
        if (IsShow == 'ALL' || IsShow == 'transectionTypeBtn') filterPopup.appendChild(transectionTypeFilterDropdown);
        if (IsShow == 'ALL' || IsShow == 'accountNameBtn') filterPopup.appendChild(accountFilterDropdown);
        if (IsShow == 'ALL' || IsShow == 'payeeBtn') filterPopup.appendChild(payeeDropdown);
        if (IsShow == 'ALL' || IsShow == 'categoryBtn') filterPopup.appendChild(categoryDropdown);
        if (IsShow == 'ALL' || IsShow == 'enteredByBtn') filterPopup.appendChild(lastUpdateDropdown);
        if (IsShow == 'ALL' || IsShow == 'isattachmentBtn') filterPopup.appendChild(isAttachedDropdown);

        filterPopup.appendChild(btnWrap);
        eventListeners();
        populateFilterDropdown();
        POPUP.show(filterPopup);
        checkValidationOfFilter();
    }

    // binding filter events
    function eventListeners() {
        var tmpactivityStartDate;
        var tmpactivityEndDate;
        var tmpminAmount;
        var tmpmaxAmount;
        var tmpaccountName;
        var tmpenteredBy;
        var tmppayee;
        var tmpcategory;
        var tmpisattachment;
        var tmptransectionType;

        fromDateInput.addEventListener('change', event => {
            tmpactivityStartDate = event.target.value;
            checkValidationOfFilter();
        });
        toDateInput.addEventListener('change', event => {
            tmpactivityEndDate = event.target.value;
            checkValidationOfFilter();
        });

        minAmountInput.addEventListener('keyup', event => {
            minAmount = event.target.value;
            var reg = new RegExp('^[0-9 . $ -]+$');
            if (!reg.test(minAmount)) {
                document.getElementById('minAmountInput').value = minAmount.substring(0, minAmount.length - 1);
                return;
            } else if (
                minAmount.includes('.') &&
                (minAmount.match(/\./g).length > 1 || minAmount.toString().split('.')[1].length > 2)
            ) {
                document.getElementById('minAmountInput').value = minAmount.substring(0, minAmount.length - 1);
                return;
            }

            tmpminAmount = minAmount.trim().replace('$', '');
            tmpminAmount = parseFloat(tmpminAmount).toFixed(2);
        });

        maxAmountInput.addEventListener('keyup', event => {
            maxAmount = event.target.value;
            var reg = new RegExp('^[0-9 . $ -]+$');
            if (!reg.test(maxAmount)) {
                document.getElementById('maxAmountInput').value = maxAmount.substring(0, maxAmount.length - 1);
                return;
            } else if (
                maxAmount.includes('.') &&
                (maxAmount.match(/\./g).length > 1 || maxAmount.toString().split('.')[1].length > 2)
            ) {
                document.getElementById('maxAmountInput').value = maxAmount.substring(0, maxAmount.length - 1);
                return;
            }
            tmpmaxAmount = maxAmount.trim().replace('$', '');
            tmpmaxAmount = parseFloat(tmpmaxAmount).toFixed(2);
        });

        transectionTypeFilterDropdown.addEventListener('change', event => {
            tmptransectionType = event.target.value;
        });
        accountFilterDropdown.addEventListener('change', event => {
            tmpaccountName = event.target.value;
        });
        lastUpdateDropdown.addEventListener('change', event => {
            tmpenteredBy =
                event.target.options[event.target.selectedIndex].innerHTML == 'ALL'
                    ? '%'
                    : event.target.options[event.target.selectedIndex].id; //event.target.options[event.target.selectedIndex].innerHTML;
            filterValues.userName = event.target.options[event.target.selectedIndex].innerHTML;
        });
        payeeDropdown.addEventListener('change', event => {
            tmppayee = event.target.value;
        });
        categoryDropdown.addEventListener('change', event => {
            tmpcategory = event.target.value;
        });
        isAttachedDropdown.addEventListener('change', event => {
            tmpisattachment = event.target.value;
        });

        APPLY_BTN.addEventListener('click',async () => {
          if (!APPLY_BTN.classList.contains('disabled')) {
                updateFilterData({
                    tmpactivityStartDate,
                    tmpactivityEndDate,
                    tmpminAmount,
                    tmpmaxAmount,
                    tmpaccountName,
                    tmpenteredBy,
                    tmppayee,
                    tmpcategory,
                    tmpisattachment,
                    tmptransectionType,
                });
                POPUP.hide(filterPopup);
                if (!reconciliationFilterOn) {
                    await loadConsumerFinanceLanding();
                }
                else {
                    await populateReconciliationGrid();
                    const reconcileStartDateBtn = document.getElementById('reconcileStartDateBtn');
                    reconcileStartDateBtn.innerHTML = 'From Date: ' + moment(reconcileFilterValues.activityStartDate, 'YYYY-MM-DD').format('M/D/YYYY');
                    const reconcileEndDateBtn = document.getElementById('reconcileEndDateBtn');
                    reconcileEndDateBtn.innerHTML = 'To Date: ' + moment(reconcileFilterValues.activityEndDate, 'YYYY-MM-DD').format('M/D/YYYY');
                    reconciliationFilterOn = false;
                }
          }
       });
    }       

    function updateFilterData(data) {
        if (!reconciliationFilterOn) {
            if (data.tmpactivityStartDate) filterValues.activityStartDate = data.tmpactivityStartDate;
            if (data.tmpactivityEndDate) filterValues.activityEndDate = data.tmpactivityEndDate;
            if (data.tmpminAmount) filterValues.minamount = data.tmpminAmount;
            if (data.tmpmaxAmount) filterValues.maxamount = data.tmpmaxAmount;
            if (data.tmpaccountName) filterValues.accountName = data.tmpaccountName;
            if (data.tmpenteredBy) filterValues.enteredBy = data.tmpenteredBy;
            if (data.tmppayee) filterValues.payee = data.tmppayee;
            if (data.tmpcategory) filterValues.category = data.tmpcategory;
            if (data.tmpisattachment) filterValues.isattachment = data.tmpisattachment;
            if (data.tmptransectionType) filterValues.transectionType = data.tmptransectionType;
        }
        else if (reconciliationFilterOn == true) {
            if (data.tmpactivityStartDate) reconcileFilterValues.activityStartDate = data.tmpactivityStartDate;
            if (data.tmpactivityEndDate) reconcileFilterValues.activityEndDate = data.tmpactivityEndDate;
            if (data.tmpminAmount) reconcileFilterValues.minamount = data.tmpminAmount;
            if (data.tmpmaxAmount) reconcileFilterValues.maxamount = data.tmpmaxAmount;
            if (data.tmpaccountName) reconcileFilterValues.accountName = data.tmpaccountName;
            if (data.tmpenteredBy) reconcileFilterValues.enteredBy = data.tmpenteredBy;
            if (data.tmppayee) reconcileFilterValues.payee = data.tmppayee;
            if (data.tmpcategory) reconcileFilterValues.category = data.tmpcategory;
            if (data.tmpisattachment) reconcileFilterValues.isattachment = data.tmpisattachment;
            if (data.tmptransectionType) reconcileFilterValues.transectionType = data.tmptransectionType;

        }
    }  

    function checkValidationOfFilter() {
        var fromDate = fromDateInput.querySelector('#fromDateInput');
        var toDate = toDateInput.querySelector('#toDateInput');

        if (fromDate.value > toDate.value) {
            toDateInput.classList.add('errorPopup');
        } else {
            toDateInput.classList.remove('errorPopup');
        }
        setBtnStatusOfFilter();
    }

    function setBtnStatusOfFilter() {
        var hasErrors = [].slice.call(document.querySelectorAll('.errorPopup'));
        if (hasErrors.length !== 0) {
            APPLY_BTN.classList.add('disabled');
            return;
        } else {
            APPLY_BTN.classList.remove('disabled');
        }
    }

    async function populateFilterDropdown() {
        const filter = !reconciliationFilterOn ? filterValues : reconcileFilterValues;
        const { getActiveAccountResult: accounts } = await ConsumerFinancesAjax.getActiveAccountAsync(
            selectedConsumersId,
            accountPermission,
        );
        let accountData = accounts.map(account => ({
            id: account.accountId,
            value: account.accountName,
            text: account.accountName,
        }));
        accountData.unshift({ id: null, value: '%', text: 'ALL' }); //ADD Blank value
        dropdown.populate('accountFilterDropdown', accountData, filter.accountName);

        const { getPayeesResult: Payees } = await ConsumerFinancesAjax.getPayeesAsync($.session.consumerId);
        let payeeData = Payees.map(payees => ({
            id: payees.CategoryID,
            value: payees.Description,
            text: payees.Description,
        }));
        payeeData.unshift({ id: null, value: '%', text: 'ALL' });
        dropdown.populate('payeeDropdown', payeeData, filter.payee);

        let categoryID;
        const { getCategoriesSubCategoriesResult: Category } = await ConsumerFinancesAjax.getCategoriesSubCategoriesAsync(
            categoryID,
        );
        let categoryData = Category.map(category => ({
            id: category.CategoryID,
            value: category.CategoryDescription,
            text: category.CategoryDescription,
        }));
        categoryData.unshift({ id: null, value: '%', text: 'ALL' });
        dropdown.populate('categoryDropdown', categoryData, filter.category);

        const { getActiveUsedByResult: employees } = await ConsumerFinancesAjax.getActiveEmployeesAsync();
        let data = employees.map(employee => ({
            id: employee.userId,
            value: employee.userId,
            text: employee.userName,
        }));
        data.unshift({ id: null, value: '%', text: 'ALL' });
        dropdown.populate('lastUpdateDropdown', data, filter.enteredBy);

        const condfidentialDropdownData = [
            { text: 'Yes', value: 'Yes' },
            { text: 'No', value: 'No' },
        ];
        condfidentialDropdownData.unshift({ id: null, value: '%', text: 'ALL' });
        dropdown.populate('isAttachedDropdown', condfidentialDropdownData, filter.isattachment);

        const TransectionTypeDropdownData = [
            { text: 'Deposit', value: 'false' },
            { text: 'Expense', value: 'true' },
        ];
        TransectionTypeDropdownData.unshift({ id: null, value: '%', text: 'ALL' });
        dropdown.populate('transectionTypeFilterDropdown', TransectionTypeDropdownData, filter.transectionType);
    }

    function filterPopupCancelBtn() {
        POPUP.hide(filterPopup);
    }
    function showReconcileFilterBtns() {

        var filteredBy = document.querySelector('.filteredByData');
        if (!filteredBy) {
            filteredBy = document.createElement('div');
            filteredBy.classList.add('filteredByData');
            reconcileFilterValues = {
                token: $.session.Token,
                activityStartDate: null,
                activityEndDate: null,
                accountName: reconcilePageData.accountName.split(' - ')[0],
                payee: '%',
                category: '%',
                minamount: '-10000.00',
                maxamount: '10000.00',
                checkNo: '',
                Balance: '',
                enteredBy: '%',
                isattachment: '%',
                transectionType: '%',
            };
            const fromDate = moment(reconcilePageData.statementDate, 'YYYY-MM-DD').subtract(30, 'day');
            reconcileFilterValues.activityStartDate = fromDate.format('YYYY-MM-DD');;
            const toDate = moment(reconcilePageData.statementDate, 'YYYY-MM-DD');
            reconcileFilterValues.activityEndDate = toDate.format('YYYY-MM-DD');
            const reconcileFilterBtn = button.build({
                text: 'Filter',
                icon: 'filter',
                style: 'secondary',
                type: 'contained',
                classNames: 'filterBtnNew',
                callback: () => {
                    showReconciliationFilterPopup('ALL');
                },
            });
            const reconcileStartDateBtn = button.build({
                id: 'reconcileStartDateBtn',
                text: 'From Date: ' + moment(reconcileFilterValues.activityStartDate, 'YYYY-MM-DD').format('M/D/YYYY'),
                style: 'secondary',
                type: 'text',
                classNames: 'filterSelectionBtn',
                callback: () => {
                    showReconciliationFilterPopup('activityStartDateBtn');
                },
            });
            const reconcileEndDateBtn = button.build({
                id: 'reconcileEndDateBtn',
                text: 'To date: ' + moment(reconcileFilterValues.activityEndDate, 'YYYY-MM-DD').format('M/D/YYYY'),
                style: 'secondary',
                type: 'text',
                classNames: 'filterSelectionBtn',
                callback: () => {
                    showReconciliationFilterPopup('activityEndDateBtn');
                },
            });
            const accountBtn = button.build({
                style: 'secondary',
                type: 'text',
                classNames: 'filterSelectionBtn',
                text: 'Account: ' + reconcileFilterValues.accountName
            });
            const reconciledBtn = button.build({
                style: 'secondary',
                type: 'text',
                classNames: 'filterSelectionBtn',
                text: 'Reconciled : No'
            });

            const reconcileFilterBtnWrap = document.createElement('div');
            reconcileFilterBtnWrap.classList.add('filterBtnWrap');
            reconcileFilterBtnWrap.style.width = '60%';
            reconcileFilterBtnWrap.appendChild(reconcileFilterBtn);

            reconcileStartDateBtnWrap = document.createElement('div');
            reconcileStartDateBtnWrap.classList.add('filterSelectionBtnWrap');
            reconcileStartDateBtnWrap.appendChild(reconcileStartDateBtn);
            reconcileFilterBtnWrap.appendChild(reconcileStartDateBtnWrap);

            reconcileEndDateBtnWrap = document.createElement('div');
            reconcileEndDateBtnWrap.classList.add('filterSelectionBtnWrap');
            reconcileEndDateBtnWrap.appendChild(reconcileEndDateBtn);
            reconcileFilterBtnWrap.appendChild(reconcileEndDateBtnWrap);

            const accountdBtnWrap = document.createElement('div');
            accountdBtnWrap.classList.add('filterSelectionBtnWrap');
            accountdBtnWrap.appendChild(accountBtn);
            reconcileFilterBtnWrap.appendChild(accountdBtnWrap);

            const reconciledBtnWrap = document.createElement('div');
            reconciledBtnWrap.classList.add('filterSelectionBtnWrap');
            reconciledBtnWrap.appendChild(reconciledBtn);
            reconcileFilterBtnWrap.appendChild(reconciledBtnWrap);

            filteredBy.appendChild(reconcileFilterBtnWrap);

        }

        filteredBy.style.maxWidth = '100%';
        return filteredBy;
    }

    function showReconciliationFilterPopup(IsShow) {
        reconciliationFilterOn = true;
        filterPopup = POPUP.build({
            classNames: ['rosterFilterPopup'],
            hideX: true,
        });

        // dropdowns & inputs
        fromDateInput = input.build({
            id: 'fromDateInput',
            type: 'date',
            label: 'From Date',
            style: 'secondary',
            value: reconcileFilterValues.activityStartDate,
        });

        toDateInput = input.build({
            id: 'toDateInput',
            type: 'date',
            label: 'To Date',
            style: 'secondary',
            value: reconcileFilterValues.activityEndDate,
        });
        minAmountInput = input.build({
            id: 'minAmountInput',
            type: 'text',
            label: 'Min Amount',
            style: 'secondary',
            value: '$' + (reconcileFilterValues.minamount ? reconcileFilterValues.minamount : ''),
        });

        maxAmountInput = input.build({
            id: 'maxAmountInput',
            type: 'text',
            label: 'Max Amount',
            style: 'secondary',
            value: '$' + (reconcileFilterValues.maxamount ? reconcileFilterValues.maxamount : ''),
        });

        transectionTypeFilterDropdown = dropdown.build({
            label: 'Transaction Type',
            dropdownId: 'transectionTypeFilterDropdown'
        });

        accountFilterDropdown = dropdown.build({
            label: 'Account',
            dropdownId: 'accountFilterDropdown',
            isReadOnly: true
        });

        payeeDropdown = dropdown.build({
            id: 'payeeDropdown',
            label: 'Payee',
            dropdownId: 'payeeDropdown'
        });

        categoryDropdown = dropdown.build({
            id: 'categoryDropdown',
            label: 'Category',
            dropdownId: 'categoryDropdown'
        });

        lastUpdateDropdown = dropdown.build({
            id: 'lastUpdateDropdown',
            label: 'Last Updated By',
            dropdownId: 'lastUpdateDropdown'
        });

        isAttachedDropdown = dropdown.build({
            id: 'isAttachedDropdown',
            label: 'Has Attachment?',
            dropdownId: 'isAttachedDropdown'
        });

        // apply filters button
        APPLY_BTN = button.build({
            text: 'Apply',
            style: 'secondary',
            type: 'contained'
        });
        CANCEL_BTN = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                reconciliationFilterOn = false;
                POPUP.hide(filterPopup);
            }
        });

        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.appendChild(APPLY_BTN);
        btnWrap.appendChild(CANCEL_BTN);

        var dateWrap = document.createElement('div');
        dateWrap.classList.add('dateWrap');
        if (IsShow == 'ALL' || IsShow == 'activityStartDateBtn') dateWrap.appendChild(fromDateInput);
        if (IsShow == 'ALL' || IsShow == 'activityEndDateBtn') dateWrap.appendChild(toDateInput);

        var amountWrap = document.createElement('div');
        amountWrap.classList.add('dateWrap');
        if (IsShow == 'ALL') amountWrap.appendChild(minAmountInput);
        if (IsShow == 'ALL') amountWrap.appendChild(maxAmountInput);

        // build popup
        filterPopup.appendChild(dateWrap);
        filterPopup.appendChild(amountWrap);
        if (IsShow == 'ALL') filterPopup.appendChild(transectionTypeFilterDropdown);
        if (IsShow == 'ALL') filterPopup.appendChild(accountFilterDropdown);
        if (IsShow == 'ALL') filterPopup.appendChild(payeeDropdown);
        if (IsShow == 'ALL') filterPopup.appendChild(categoryDropdown);
        if (IsShow == 'ALL') filterPopup.appendChild(lastUpdateDropdown);
        if (IsShow == 'ALL') filterPopup.appendChild(isAttachedDropdown);

        filterPopup.appendChild(btnWrap);
        eventListeners();
        populateFilterDropdown();
        POPUP.show(filterPopup);
        checkValidationOfFilter();
        if (document.getElementById('accountFilterDropdown')) document.getElementById('accountFilterDropdown').classList.add('disabled');
        var endDate = document.getElementById('toDateInput');
        if (endDate) {
            endDate.max = reconcilePageData.statementDate;
            endDate.addEventListener("change", function () {
                if (this.value > reconcilePageData.statementDate) {
                    this.value = "";
                }
            });
        }
    }
    function showUndoConfirmationPopup() {
        const undoPopup = POPUP.build({
            classNames: 'warning',
            hideX: false,
        });

        const title = document.createElement('h3');
        title.textContent = 'Undo Last Reconciliation';
        undoPopup.appendChild(title);

        const message = document.createElement('p');
        message.innerHTML = `
        When you have finished undoing the last reconciliation, your beginning balance will be 
        reverted back to the previous beginning balance shown below:<br><br>
        <strong>Current Beginning Balance:</strong> $${parseFloat(selectedAccountData.reconciledBalance || '0').toFixed(2)}<br>
        <strong>Previous Beginning Balance:</strong> $${parseFloat(selectedAccountData.priorReconciledBalance || '0').toFixed(2)}
        <br><br>
        Undoing the last reconciliation also removes the cleared status of all its transactions, service 
        charges, interest, and balance adjustments. You will need to reconcile your previous statement again.
        <br><br>Do you want to continue?
    `;
        undoPopup.appendChild(message);

        const buttonContainer = document.createElement('div');
        buttonContainer.style.display = 'flex';
        buttonContainer.style.gap = '10px';
        buttonContainer.style.marginTop = '20px';
        buttonContainer.style.justifyContent = 'center';

        const continueBtn = button.build({
            text: 'CONTINUE',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                POPUP.hide(undoPopup);
                await performUndoReconciliation();
                showUndoCompletePopup();
            },
        });

        const cancelBtn = button.build({
            text: 'CANCEL',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                POPUP.hide(undoPopup);
            },
        });

        continueBtn.style.width = '180px';
        cancelBtn.style.width = '180px';
        buttonContainer.appendChild(continueBtn);
        buttonContainer.appendChild(cancelBtn);
        undoPopup.appendChild(buttonContainer);

        POPUP.show(undoPopup);
    }

    async function performUndoReconciliation() {
        try {
            await ConsumerFinancesAjax.undoLastReconciliation({
                token: $.session.Token,
                accountId: selectedAccountData.accountId || selectedAccountData.id,
                consumerId: selectedConsumersId
            });
            await loadConsumerFinanceLanding();
        } catch (error) {
            console.error('Error undoing reconciliation:', error);
            alert('Error undoing reconciliation. Please try again.');
        }
    }
    function showUndoCompletePopup() {
        const completePopup = POPUP.build({
            classNames: 'warning',
            hideX: false,
        });

        const title = document.createElement('h3');
        title.textContent = 'Reconciliation Undone';
        completePopup.appendChild(title);

        const message = document.createElement('p');
        message.innerHTML = `
        The 'Undo' of the last reconciliation is complete.<br><br>
        Service charge, interest, and balance adjustments have not been removed. 
        If you want to reconcile from scratch, you must manually remove these transactions from your register.
    `;
        completePopup.appendChild(message);

        const okBtn = button.build({
            text: 'OK',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                POPUP.hide(completePopup);
                if (reconcilePopup) {
                    POPUP.hide(reconcilePopup);
                }
            },
        });

        okBtn.style.width = '100%';
        okBtn.style.marginTop = '25px';
        completePopup.appendChild(okBtn);
        POPUP.show(completePopup);
    }

    async function startReconciliation() {
        const statementDateEl = document.getElementById('statementDate');
        const statementBalanceEl = document.getElementById('statementBalance');
        const interestEl = document.getElementById('interest');
        const serviceEl = document.getElementById('service');

        if (!statementDateEl || !statementBalanceEl) {
            alert('Please fill in all required fields.');
            return;
        }

        reconcilePageData = {
            accountId: selectedAccountData.accountId || selectedAccountData.id,
            accountName: selectedAccountData.text,
            statementDate: statementDateEl.value,
            statementBalance: parseFloat(statementBalanceEl.value.replace(/[$,]/g, '') || '0'),
            interest: parseFloat(interestEl.value.replace(/[$,]/g, '') || '0'),
            service: parseFloat(serviceEl.value.replace(/[$,]/g, '') || '0'),
            reconciledBalance: parseFloat(selectedAccountData.reconciledBalance || '0')
        };

        POPUP.hide(reconcilePopup);
        await loadReconciliationPage();
    }

    async function loadReconciliationPage() {
        DOM.clearActionCenter();
        showMiniRosterBtn(false);

        const reconcilePage = document.createElement('div');
        reconcilePage.classList.add('reconcilePage');

        const header = document.createElement('div');
        const accounReadOnly = input.build({
            id: 'accounReadOnly',
            value: reconcilePageData.accountName,
            type: 'text',
            style: 'secondary',
            label: 'Accounts',
            readonly: true
        });
        const selectAllBtn = button.build({
            text: 'Select All',
            style: 'secondary',
            type: 'contained',
            callback: () => selectAllReconcileRows(true),
        });
        const selectNoneBtn = button.build({
            text: 'Select None',
            style: 'secondary',
            type: 'contained',
            callback: () => selectAllReconcileRows(false),
        });
        accounReadOnly.style.width = '40%';
        selectAllBtn.style.width = '45%';
        selectNoneBtn.style.width = '45%';
        selectAllBtn.style.height = '50px';
        selectNoneBtn.style.height = '50px';
        const selectBtnContainer = document.createElement('div');
        selectBtnContainer.style.width = '65%';
        selectBtnContainer.style.display = 'flex';
        selectBtnContainer.style.gap = '10px';
        selectBtnContainer.style.justifyContent = 'right';
        selectBtnContainer.style.float = 'right';
        selectBtnContainer.style.marginTop = '-70px';
        selectBtnContainer.appendChild(selectAllBtn);
        selectBtnContainer.appendChild(selectNoneBtn);
        header.appendChild(accounReadOnly);
        header.appendChild(selectBtnContainer);
        reconcilePage.appendChild(header);

        const controls = document.createElement('div');
        controls.classList.add('reconcileControls');
        controls.style.display = 'flex';
        controls.style.justifyContent = 'space-between';
        controls.style.alignItems = 'center';
        controls.style.marginBottom = '20px';
        controls.style.width = '100%';

        const leftControls = document.createElement('div');
        leftControls.style.display = 'flex';
        leftControls.style.gap = '10px';
        leftControls.style.width = '100%';
        const filteredBy = showReconcileFilterBtns();
        filteredBy.style.width = '100%';
        const rightAmounts = document.createElement('div');
        rightAmounts.style.textAlign = 'right';
        rightAmounts.style.width = '40%';
        const amountToReconcile = document.createElement('div');
        amountToReconcile.innerHTML = '<strong>Amount to be Reconciled: <span id="amountToReconcile">$0.00</span></strong>';

        const reconciledBalance = document.createElement('div');
        reconciledBalance.innerHTML = '<strong>Reconciled Balance: <span id="reconciledBalance">$0.00</span></strong>';

        rightAmounts.appendChild(amountToReconcile);
        rightAmounts.appendChild(reconciledBalance);

        filteredBy.appendChild(rightAmounts);
        leftControls.appendChild(filteredBy);
        controls.appendChild(leftControls);
        //controls.appendChild(rightAmounts);
        reconcilePage.appendChild(controls);

        await buildReconciliationGrid();
        tableUnreconciled.style.width = '100%';
        reconcilePage.appendChild(tableUnreconciled);
        await populateReconciliationGrid();

        const bottomButtons = document.createElement('div');
        bottomButtons.style.display = 'flex';
        bottomButtons.style.gap = '10px';
        bottomButtons.style.marginTop = '20px';
        bottomButtons.style.justifyContent = 'center';

        const stopBtn = button.build({
            text: 'STOP RECONCILIATION',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                showReconcileAccountPopup(reconcilePageData);
            },
        });

        const finishBtn = button.build({
            id: 'finishBtn',
            text: 'FINISH RECONCILIATION',
            style: 'secondary',
            type: 'contained',
            callback: () => finishReconciliation(),
        });

        bottomButtons.appendChild(stopBtn);
        bottomButtons.appendChild(finishBtn);
        reconcilePage.appendChild(bottomButtons);

        DOM.ACTIONCENTER.appendChild(reconcilePage);
        toggleFinishBtn();
        updateReconcileAmounts();

    }

    async function buildReconciliationGrid() {
        const reconcileTransactionsTableEle = document.querySelector('#singleEntryAdminReviewTable');
        reconcileTransactionsTableEle?.remove();
        const consumers = (
            await ConsumerFinancesAjax.getConsumerNameByID({
                token: $.session.Token,
                consumerId: selectedConsumersId,
            })
        ).getConsumerNameByIDResult;

        const tableOptions = {
            plain: false,
            tableId: 'singleEntryAdminReviewTable',
            headline: consumers[0].FullName,
            columnHeadings: ['Date', 'Payee', 'Category', 'Deposit', 'Expense', 'Check No.', 'Entered By'],
        };

        tableUnreconciled = table.build(tableOptions);
    }

    async function populateReconciliationGrid() {

        const transactions = await ConsumerFinancesAjax.getUnreconciledTransactionsAsync({
            token: $.session.Token,
            consumerId: selectedConsumersId,
            accountId: reconcilePageData.accountId,
            fromDate: reconcileFilterValues.activityStartDate,
            toDate: reconcileFilterValues.activityEndDate,
            accountName: reconcileFilterValues.accountName,
            payee: reconcileFilterValues.payee,
            category: reconcileFilterValues.category,
            minamount: reconcileFilterValues.minamount,
            maxamount: reconcileFilterValues.maxamount,
            enteredBy: reconcileFilterValues.enteredBy,
            checkNo: reconcileFilterValues.checkNo,
            balance: reconcileFilterValues.balance,
            isattachment: reconcileFilterValues.isattachment,
            transectionType: reconcileFilterValues.transectionType,
            accountPermission: accountPermission
        });

        reconcileGridData = transactions.getUnreconciledTransactionsResult || [];
        const tableData = reconcileGridData.map(entry => {
            const newDate = moment(entry.activity_date);
            const formatActivityDate = newDate.format('MM/DD/YYYY');

            return {
                values: [
                    formatActivityDate,
                    entry.payee || entry.payee2 || '',
                    entry.category || '',
                    entry.deposit_amount ? '$' + parseFloat(entry.deposit_amount).toFixed(2) : '',
                    entry.expense_amount ? '$' + parseFloat(entry.expense_amount).toFixed(2) : '',
                    entry.checkno || '',
                    entry.enteredby
                ],
                attributes: [
                    { key: 'data-register-id', value: entry.register_id },
                    { key: 'data-deposit', value: entry.deposit_amount || '0' },
                    { key: 'data-expense', value: entry.expense_amount || '0' },
                ],
                onClick: e => {
                    toggleReconcileRow(e.target);
                },
            };
        });

        // Set the data type for each header, for sorting purposes
        const headers = tableUnreconciled.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'date'); // Date       
        headers[1].setAttribute('data-type', 'string'); // Payee
        headers[2].setAttribute('data-type', 'string'); // Category
        headers[3].setAttribute('data-type', 'amount'); // deposit
        headers[4].setAttribute('data-type', 'amount'); // expense
        headers[5].setAttribute('data-type', 'string'); // check no   
        headers[6].setAttribute('data-type', 'string'); // entered by 
        table.sortTableByHeader(tableUnreconciled);
        table.populate(tableUnreconciled, tableData);
        toggleFinishBtn();
    }
    function toggleReconcileRow(row) {
        if (row.classList.contains('selected')) {
            row.classList.remove('selected');
            row.style.backgroundColor = '';
        } else {
            row.classList.add('selected');
            row.style.backgroundColor = '#90EE90';
        }
        toggleFinishBtn();
        updateReconcileAmounts();
    }
    function toggleFinishBtn() {
        const finishBtn = document.getElementById('finishBtn');
        if (finishBtn) {
            const rows = document.querySelectorAll('#singleEntryAdminReviewTable .table__body .table__row.selected');
            if (rows?.length > 0) finishBtn.classList.remove('disabled');
            else finishBtn.classList.add('disabled');
        }
    }
    function selectAllReconcileRows(select) {
        const rows = document.querySelectorAll('#singleEntryAdminReviewTable .table__body .table__row');
        rows.forEach(row => {
            if (select) {
                row.classList.add('selected');
                row.style.backgroundColor = '#90EE90';
            } else {
                row.classList.remove('selected');
                row.style.backgroundColor = '';
            }
        });
        toggleFinishBtn();
        updateReconcileAmounts();
    }
    function updateReconcileAmounts() {
        const selectedRows = document.querySelectorAll('#singleEntryAdminReviewTable .table__body .table__row.selected');
        let totalDeposits = 0;
        let totalExpenses = 0;

        selectedRows.forEach(row => {
            const deposit = parseFloat(row.getAttribute('data-deposit') || '0');
            const expense = parseFloat(row.getAttribute('data-expense') || '0');
            totalDeposits += deposit;
            totalExpenses += expense;
        });

        const amountToReconcile = reconcilePageData.statementBalance -
            reconcilePageData.reconciledBalance -
            reconcilePageData.interest +
            reconcilePageData.service -
            totalDeposits +
            totalExpenses;

        const reconciledBalance = reconcilePageData.reconciledBalance +
            reconcilePageData.interest -
            reconcilePageData.service +
            totalDeposits -
            totalExpenses;

        const amountEl = document.getElementById('amountToReconcile');
        const balanceEl = document.getElementById('reconciledBalance');

        if (amountEl) amountEl.textContent = '$' + amountToReconcile.toFixed(2);
        if (balanceEl) balanceEl.textContent = '$' + reconciledBalance.toFixed(2);
    }

    async function finishReconciliation() {
        const amountToReconcileEl = document.getElementById('amountToReconcile');
        if (!amountToReconcileEl) return;

        const amountToReconcile = parseFloat(amountToReconcileEl.textContent.replace('$', ''));
        const reconciledBalance = parseFloat(document.getElementById('reconciledBalance').textContent.replace('$', ''));
        if (amountToReconcile === 0) {
            await completeReconciliation();

            if (reconcilePageData.interest !== 0 || reconcilePageData.service !== 0) {
                showCategorySelectionPopup(0);
            } else {
                await loadConsumerFinanceLanding();
            }
        }
        else
        {
            showReconcileConfirmationPopup(amountToReconcile);
        }
    }
    function showReconcileConfirmationPopup(difference) {
        const confirmPopup = POPUP.build({
            classNames: 'warning',
            hideX: false,
        });

        const title = document.createElement('h3');
        title.textContent = 'Reconciliation Difference';
        confirmPopup.appendChild(title);

        const message = document.createElement('p');
        message.innerHTML = `The statement balance does not match the reconciled balance. Do you want to create an adjusting entry? `;
        confirmPopup.appendChild(message);

        const buttonContainer = document.createElement('div');
        buttonContainer.style.display = 'flex';
        buttonContainer.style.gap = '10px';
        buttonContainer.style.marginTop = '20px';
        buttonContainer.style.justifyContent = 'center';

        const yesBtn = button.build({
            text: 'YES',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                POPUP.hide(confirmPopup);
                await completeReconciliation();
                showCategorySelectionPopup(difference);
            },
        });

        const noBtn = button.build({
            text: 'NO',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                POPUP.hide(confirmPopup);
            },
        });

        yesBtn.style.width = '150px';
        noBtn.style.width = '150px';
        buttonContainer.appendChild(yesBtn);
        buttonContainer.appendChild(noBtn);
        confirmPopup.appendChild(buttonContainer);

        POPUP.show(confirmPopup);
    }

    async function completeReconciliation() {
        const selectedRows = document.querySelectorAll('#singleEntryAdminReviewTable .table__body div.table__row.selected');
        const selectedIds = Array.from(selectedRows).map(row => row.getAttribute('data-register-id'));       
        try {
            await ConsumerFinancesAjax.completeReconciliation({
                token: $.session.Token,
                accountId: reconcilePageData.accountId,
                consumerId: selectedConsumersId,
                selectedTransactionIds: selectedIds.join(','),
                statementDate: reconcilePageData.statementDate,
                statementBalance: reconcilePageData.statementBalance,
                userId: $.session.UserId
            });
        } catch (error) {
            console.error('Error completing reconciliation:', error);
            throw error;
        }
    }

    async function showCategorySelectionPopup(difference) {
        const pop = POPUP.build({ classNames: ['categorySelectionPopup'], hideX: false });

        const showInterest = reconcilePageData.interest !== 0;
        const showService = reconcilePageData.service !== 0;
        const showAdjustment = Math.abs(difference) !== 0;

        let interestWrap = document.createElement('div');
        let serviceWrap = document.createElement('div');
        let adjustWrap = document.createElement('div');

        interestWrap.style.display = showInterest ? 'block' : 'none';
        serviceWrap.style.display = showService ? 'block' : 'none';
        adjustWrap.style.display = showAdjustment ? 'block' : 'none';

        const interestDD =  dropdown.build({
            label: 'Interest Category',
            dropdownId: 'interestCategoryDD'
        });
        interestWrap.appendChild(interestDD);

        const serviceDD = dropdown.build({
            label: 'Service Category',
            dropdownId: 'serviceCategoryDD'
        });
        serviceWrap.appendChild(serviceDD);

        const adjustDD = dropdown.build({
            label: 'Adjustment Category',
            dropdownId: 'adjustCategoryDD'
        });
        adjustWrap.appendChild(adjustDD);

        pop.appendChild(interestWrap);
        pop.appendChild(serviceWrap);
        pop.appendChild(adjustWrap);

        const btnWrap = document.createElement('div');
        btnWrap.style.display = 'flex';
        btnWrap.style.gap = '10px';
        btnWrap.style.marginTop = '15px';

        const applyBtn = button.build({
            text: 'APPLY',
            style: 'secondary',
            type: 'contained',
            classNames: ['disabled'],
            callback: async () => {
                if (applyBtn.classList.contains('disabled')) return;

                const interestVal = showInterest ? document.getElementById('interestCategoryDD').value : null;
                const serviceVal = showService ? document.getElementById('serviceCategoryDD').value : null;
                const adjustVal = showAdjustment ? document.getElementById('adjustCategoryDD').value : null;

                if (showAdjustment && adjustVal) {
                    POPUP.hide(pop);
                    showAdjustingEntryPopup(async (reason) => {
                        await insertReconciliationTransactions(interestVal, serviceVal, adjustVal, reason, difference);
                        await loadConsumerFinanceLanding();
                    });
                } else {
                    await insertReconciliationTransactions(interestVal, serviceVal, adjustVal, null, difference);
                    POPUP.hide(pop);
                    await loadConsumerFinanceLanding();
                }
            }
        });

        const cancelBtn = button.build({
            text: 'CANCEL',
            style: 'secondary',
            type: 'outlined',
            callback: () => POPUP.hide(pop)
        });

        applyBtn.style.height = '50px';
        applyBtn.style.width = '185px';
        applyBtn.style.fontSize = '18px';
        cancelBtn.style.height = '50px';
        cancelBtn.style.width = '185px';
        applyBtn.style.fontSize = '18px';
        btnWrap.appendChild(applyBtn);
        btnWrap.appendChild(cancelBtn);
        pop.appendChild(btnWrap);

        function checkApply() {
            let ok = true;
            if (showInterest) {
                const val = document.getElementById('interestCategoryDD').value;
                if (!val || val === '') ok = false;
            }
            if (showService) {
                const val = document.getElementById('serviceCategoryDD').value;
                if (!val || val === '') ok = false;
            }
            if (showAdjustment) {
                const val = document.getElementById('adjustCategoryDD').value;
                if (!val || val === '') ok = false;
            }
            ok ? applyBtn.classList.remove('disabled') : applyBtn.classList.add('disabled');
        }

        setTimeout(async () => {
            const categoriesResult = await ConsumerFinancesAjax.getCategoriesSubCategoriesAsync(null);
            const categories = categoriesResult.getCategoriesSubCategoriesResult || [];
            const categoryData = categories
                .filter(cat => cat.CategoryDescription !== '--SPLIT--')
                .map(cat => ({
                    id: cat.CategoryID,
                    value: cat.CategoryID,
                    text: cat.CategoryDescription,
                }));

            const interestDefault = await ConsumerFinancesAjax.getSystemSettingCategory('InterestCategory');
            const serviceDefault = await ConsumerFinancesAjax.getSystemSettingCategory('ServiceCategory');
            const adjustDefault = await ConsumerFinancesAjax.getSystemSettingCategory('AdjustingCategory');

            const interestDefaultValue = interestDefault && interestDefault.getSystemSettingCategoryResult && interestDefault.getSystemSettingCategoryResult !== '0' ? interestDefault.getSystemSettingCategoryResult : '';
            const serviceDefaultValue = serviceDefault && serviceDefault.getSystemSettingCategoryResult && serviceDefault.getSystemSettingCategoryResult !== '0' ? serviceDefault.getSystemSettingCategoryResult : '';
            const adjustDefaultValue = adjustDefault && adjustDefault.getSystemSettingCategoryResult && adjustDefault.getSystemSettingCategoryResult !== '0' ? adjustDefault.getSystemSettingCategoryResult : '';

            if (showInterest) {
                dropdown.populate('interestCategoryDD', categoryData, interestDefaultValue);
                document.getElementById('interestCategoryDD').addEventListener('change', checkApply);
            }
            if (showService) {
                dropdown.populate('serviceCategoryDD', categoryData, serviceDefaultValue);
                document.getElementById('serviceCategoryDD').addEventListener('change', checkApply);
            }
            if (showAdjustment) {
                dropdown.populate('adjustCategoryDD', categoryData, adjustDefaultValue);
                document.getElementById('adjustCategoryDD').addEventListener('change', checkApply);
            }

            checkApply();
        }, 100);

        POPUP.show(pop);
    }

    async function insertReconciliationTransactions(interestCatId, serviceCatId, adjustCatId, adjustReason, difference) {
        try {
            await ConsumerFinancesAjax.insertReconciliationEntries({
                token: $.session.Token,
                consumerId: selectedConsumersId,
                accountId: reconcilePageData.accountId,
                statementDate: reconcilePageData.statementDate,
                statementBalance: reconcilePageData.statementBalance,
                interestAmount: reconcilePageData.interest,
                serviceAmount: reconcilePageData.service,
                adjustmentAmount: difference,
                interestCategoryId: interestCatId,
                serviceCategoryId: serviceCatId,
                adjustmentCategoryId: adjustCatId,
                adjustmentReason: adjustReason,
                userId: $.session.UserId
            });
        } catch (error) {
            console.error('Error inserting reconciliation transactions:', error);
            alert('Error completing reconciliation. Please try again.');
        }
    }
    function showAdjustingEntryPopup(callback) {
        const pop = POPUP.build({ classNames: ['adjustingEntryPopup'], hideX: false });

        const title = document.createElement('h3');
        title.style.marginBottom = '25px';
        title.textContent = 'Adjusting Entry Reason';
        pop.appendChild(title);

        const reasonInput = input.build({
            id: 'adjustReason',
            type: 'textarea',
            label: 'Reason *',
            style: 'secondary'
        });
        reasonInput.style.height = '100px';
        pop.appendChild(reasonInput);

        const btnWrap = document.createElement('div');
        btnWrap.style.display = 'flex';
        btnWrap.style.gap = '10px';
        btnWrap.style.marginTop = '15px';

        const saveBtn = button.build({
            text: 'SAVE',
            style: 'secondary',
            type: 'contained',
            classNames: ['disabled'],
            callback: () => {
                if (saveBtn.classList.contains('disabled')) return;
                const reasonVal = document.getElementById('adjustReason').value.trim();
                POPUP.hide(pop);
                callback(reasonVal);
            }
        });

        const cancelBtn = button.build({
            text: 'CANCEL',
            style: 'secondary',
            type: 'outlined',
            callback: () => POPUP.hide(pop)
        });

        saveBtn.style.width = '185px';
        cancelBtn.style.width = '180px';
        btnWrap.appendChild(saveBtn);
        btnWrap.appendChild(cancelBtn);
        pop.appendChild(btnWrap);

        setTimeout(() => {
            const inputEl = document.getElementById('adjustReason');
            if (inputEl) {
                inputEl.addEventListener('input', () => {
                    if (inputEl.value.trim() !== '') {
                        saveBtn.classList.remove('disabled');
                        inputEl.parentElement.classList.remove('error');
                    } else {
                        saveBtn.classList.add('disabled');
                        inputEl.parentElement.classList.add('error');
                    }
                });
                inputEl.parentElement.classList.add('error');
            }
        }, 50);

        POPUP.show(pop);
    }
    function showMiniRosterBtn(isVisible) {
        const rosterBtn = document.getElementById('mini_roster');
        if (!isVisible) {
            rosterBtn?.classList.add('hidden')
        }
        else {
            rosterBtn?.classList.remove('hidden')
        }
    }

    function init() {
        setActiveModuleAttribute('ConsumerFinances');
        DOM.clearActionCenter();

        let defaultCFLocation = defaults.getLocation('moneyManagement');
        if (defaultCFLocation === '') {
            defaults.setLocation('moneyManagement', 0);
            defaultCFLocation = '0';
        }
        roster2.miniRosterinit(
            {
                locationId: defaultCFLocation,
                locationName: '',
            },
            {
                hideDate: true,
            },
        );

        roster2.showMiniRoster();
    }

    return {
        init,
        handleActionNavEvent,
        loadConsumerFinanceLanding,
        getaccountPermission,
        backFromConsumerFinanceEditAccount,
    };
})();
